/**
 * @fileoverview Middleware Redux para persistir globalData no localStorage.
 * Escuta mutations no slice globalData e grava automaticamente.
 *
 * @module globalDataPersistMiddleware
 * @since 2.0.0
 */

/**
 * Chaves do localStorage alinhadas com globalContextService.
 */
const STORAGE_KEYS = {
  products: 'vikanaweb_products',
  categories: 'vikanaweb_categories',
  brands: 'vikanaweb_brands',
  promotions: 'vikanaweb_promotions',
};

/**
 * Mapeia action types para a chave de dados correspondente.
 */
const ACTION_TO_KEY = {
  'globalData/setProducts': 'products',
  'globalData/setCategories': 'categories',
  'globalData/setBrands': 'brands',
  'globalData/setPromotions': 'promotions',
};
 
/**
 * Middleware que persiste dados do globalData no localStorage.
 * @param {Object} store - Redux store
 * @returns {Function} Middleware function
 */
const globalDataPersistMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const dataKey = ACTION_TO_KEY[action.type];
  if (dataKey) {
    try {
      const data = store.getState().globalData[dataKey];
      localStorage.setItem(STORAGE_KEYS[dataKey], JSON.stringify(data));
    } catch (error) {
      console.error(`Erro ao persistir ${dataKey} no localStorage:`, error);
    }
  }

  return result;
};

export default globalDataPersistMiddleware;
